/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SelectFieldOption } from '@squiz/sds';
import { buildSelectOptions } from '../../../SegmentBuilder/utils/BuildSelectOptions/BuildSelectOptions';

export const RULE_TYPE_MAP = new Map<string, string>([
  ['<', 'Less than'],
  ['<=', 'Less than or equal'],
  ['>', 'Greater than'],
  ['>=', 'Greater than or equal'],
  ['===', 'Equals'],
  ['!==', 'Does not equal'],
  ['contains', 'Contains'],
  ['not-contains', 'Does not contain'],
  ['regex', 'Regex'],
  ['not-regex', 'Not regex'],
]);

export const RULE_TYPE_MAP_NUMERIC = new Map<string, string>([
  ['<', 'Less than'],
  ['<=', 'Less than or equal'],
  ['>', 'Greater than'],
  ['>=', 'Greater than or equal'],
  ['===', 'Equals'],
  ['!==', 'Does not equal'],
]);

/**
 * All rule select options used in the SegmentRules component.
 * @export
 */
export const RULE_OPTIONS: Array<SelectFieldOption> = buildSelectOptions(RULE_TYPE_MAP);

/**
 * Numeric rule select options used in the SegmentRules component.
 * @export
 */
export const RULE_OPTIONS_NUMERIC: Array<SelectFieldOption> = buildSelectOptions(RULE_TYPE_MAP_NUMERIC);
